module.exports = __webpack_public_path__ + "img/violet_110.355be029.png";